import { G_DROPDOWN__field_image__transform } from '@/pages/page_generation/sidebar/image_asset/G_DROPDOWN__field_image__transform';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { G_GRAPH__BUTTON__image_download } from '../_base/_buttons/G_GRAPH__BUTTON__image_download';
import { G_GRAPH__BUTTON__image_view_or_edit } from '../_base/_buttons/G_GRAPH__BUTTON__image_view_or_edit';

interface PROPS {
  field: FIELD__image_asset;
}

export function G_BAR__image_asset_actions_left({ field }: PROPS) {
  const { GRID_CELL_SIZE } = CONSTANTS__shared;

  return (
    <div className="flex flex-col items-center justify-start h-full" style={{ width: `${GRID_CELL_SIZE}px` }}>
      <G_GRAPH__BUTTON__image_download {...{ field }} />
      <G_GRAPH__BUTTON__image_view_or_edit {...{ field }} />
      <G_DROPDOWN__field_image__transform {...{ field }} />
    </div>
  );
}
